import { Activityeditor } from '@linktivity/gds-neo';
import config from '../config';

const contractApi = new Activityeditor.ContractApi(config);

export default contractApi;
